import type { FoldingCardProp } from "@components/FoldingCardProp.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsDigi(tenant: Tenant): FoldingCardProp[] {
	return [
		{
			title: "Úspora času",
			desc: "sp[[Zautomatizujete]] rutinní úkoly, jako je zpracování faktur nebo odpovídání na e-maily.",
			bg: "bg-fstgrey-400",
		},
		{
			title: "Méně chyb",
			desc: "Automatizace sp[[eliminuje lidské chyby]] při zadávání dat, schvalování dokumentů nebo evidenci objednávek.",
			bg: "bg-fstgrey-500",
		},
		{
			title: "Nižší náklady",
			desc: "Méně manuální práce znamená sp[[nižší náklady]] na zaměstnance i méně papírů a tisku.",
			bg: "bg-fstgrey-600",
		},
		{
			title: "Konkurenční výhoda",
			desc: "Digitalizované firmy jsou sp[[flexibilnější, inovativnější]] a zvládnou rychle reagovat na změny trhu.",
			bg: "bg-fstgrey-700",
		},
		{
			title: "Spokojenější zákazníci",
			desc: "Rychlejší odpovědi nebo personalizace služeb přinesou výsledky v podobě sp[[vyšší spokojenost zákazníků.]]",
			bg: "bg-fstgrey-800",
		},
		{
			title: "Snadné škálování",
			desc: "Díky digitalizaci a automatizaci sp[[podnikání poroste]] i bez nutnosti náboru dalších zaměstnanců (např. v administrativě).",
			bg: "bg-fstgrey-900",
		},
	];
}
